import React from 'react';
// import { Link } from 'react-router';
// import ReactDOM from 'react-dom';
// import jQuery from 'jquery';
import autoBind from 'auto-bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import * as SVGICONS from '../../images/img/images';
import * as disputeActions from '../../../actions/disputeActions';

// import * as signinActions from '../../actions/signinActions';
// import { ToastContainer, toast } from 'react-toastify';
import validator from './../../common/validator.js';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';

import {
	Modal,
} from 'react-bootstrap';

class AddDispute extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			dispute: {
				value: '',
				isValid: false,
				message: ''
			},
			subDispute: {
				value: '',
				isValid: false,
				message: ''
			},
			resolution: {
				value: '',
				isValid: false,
				message: ''
			},
		};
		this.handleChange = this.handleChange.bind(this)
	}
	handleChange(event) {
		var state = this.state;
		console.log("ddddddd", state, event.target.name)
		state[event.target.name].value = event.target.value;


		//validation code
		if (event.target.name == "dispute") {
			if (event.target.value.length > 0) {
				if (!validator.isValidName(event.target.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Please Enter Dispute Category';

				} else if (event.target.value.length > 26) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Please Enter Dispute within 15 Characters';
				} else {
					state[event.target.name].isValid = true;
					state[event.target.name].message = '';
				}
			} else {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Please Enter Dispute Category';
			}
		}
		if (event.target.name == "subDispute") {
			if (event.target.value.length > 0) {
				if (!validator.isValidName(event.target.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Please Enter Sub-Dispute Category';
				} else {
					state[event.target.name].isValid = true;
					state[event.target.name].message = '';
				}
			} else {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Please Enter Sub-Dispute Category';
			}
		}
		else if (event.target.name == "resolution") {
			if (event.target.value.length > 0) {
				if (!validator.isValidName(event.target.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Please Enter Resolution For this Dispute';
				} else {
					state[event.target.name].isValid = true;
					state[event.target.name].message = '';
				}
			} else {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Please Enter Resolution For this Dispute';
			}

		}

		this.setState(state);
	}
	addDisputeCategory = () => {
		let state = this.state
		let type = this.props.title;

		if (type == 'dispute'){
		if (state.dispute.isValid && state.resolution.isValid) {
			// let disputeObj = {
			// 	disputeCategory : this.state.dispute.value,
			// 	subDispute: this.state.subDispute.value,
			// 	description: this.state.resolution.value,
			// }
			let state = this.state;
			let disputeObj = {
				// disputeCategory: state.dispute.value,
				title: state.dispute.value,
				description: state.resolution.value,
			}
			this.setState({
				savingDisputeCategory: true
			})
			this.props.disputeActions.addDisputeCategory(disputeObj, this.props)

		} else {
			console.log("DISPUT$E IS EVLAU", state)
			state.dispute.message = state.dispute.isValid ? '' : "Please Enter Dispute Category"
			// state.subDispute.message = state.subDispute.isValid ? '' : "Please Enter Sub-Dispute Category"
			state.resolution.message = state.resolution.isValid ? '' : "Please Enter Resolution For this Dispute"
			this.setState(state)
		}
	} else if (type == 'language'){
		if (state.dispute.isValid && state.resolution.isValid) {
			// let disputeObj = {
			// 	disputeCategory : this.state.dispute.value,
			// 	subDispute: this.state.subDispute.value,
			// 	description: this.state.resolution.value,
			// }
			let state = this.state;
			let disputeObj = {
				// disputeCategory: state.dispute.value,
				title: state.dispute.value,
				description: state.resolution.value,
			}
			this.setState({
				savingDisputeCategory: true
			})
			this.props.disputeActions.addDisputeCategory(disputeObj, this.props)

		} else {
			console.log("DISPUT$E IS EVLAU", state)
			state.dispute.message = state.dispute.isValid ? '' : "Please Enter Language Title"
			// state.subDispute.message = state.subDispute.isValid ? '' : "Please Enter Sub-Dispute Category"
			state.resolution.message = state.resolution.isValid ? '' : "Please Enter Description For this Language"
			this.setState(state)
		}
	}
	}
	componentWillReceiveProps(nextProps) {
		console.log("cloeseaddedsubdisputemod==>", nextProps)
		if (nextProps.disputeContentAdded && this.state.savingDisputeCategory) {
			console.log("cloeseaddedsubdisputemod==>", this.props)
			this.props.closeAddDisputeModal();
			this.setState({
				savingDisputeCategory: false
			})
		}
	}
	render() {
		console.log('openAddDisputeModal:', this.props)

		const { title } = this.props
		return (
			<Modal className="blockAvailability" show={this.props.openAddDisputeModal} size="lg" onHide={this.props.closeAddDisputeModal}>
				<Modal.Header>
					<Modal.Title align="left">
						{/* <h4>Recurrence <span><i class="fa fa-refresh recur ml-20"></i></span></h4> */}
						{/* <div className="tooltip-custom fadeEffect posabr00 pull-right subRight helpsvg mobileposavr00" data-title="Enter blocks of time where you will be unavailable and select the appropriate reason."> */}
						{/* </div> */}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-sm-12">
							<div className="loginInput1">
								<div className="row">
									<div className="col-sm-4">
										<div className="">
											<label>{title == 'dispute' ? 'Dispute Category' : 'Language'} </label>
										</div>
									</div>
									<div className="col-sm-8">
										<div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
											<input style={{ width: '100%' }} name="dispute" type="text" value={this.state.dispute ? this.state.dispute.value : ''} onChange={this.handleChange} placeholder="Enter Title Here" />
										</div>
										<span className="help-block">{this.state.dispute.message}</span>
									</div>
								</div>
							</div>
						</div>

						{/* <div className="col-sm-12">
							<div className="loginInput1">
								<div className="row">
									<div className="col-sm-4">
										<div className="">
											<label >Sub-Dispute Category </label>
										</div>
									</div>
									<div className="col-sm-8">
										<div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
											<input style={{ width: '100%' }} name="subDispute" type="text" value={this.state.subDispute.value} onChange={this.handleChange} />
										</div>
										<span className="help-block">{this.state.subDispute.message}</span>
									</div>
								</div>
							</div>
						</div> */}
						<div className="col-sm-12">
							<div className="loginInput1">
								<div className="row">
									<div className="col-sm-4">
										<div className="">
											<label> Description </label>
										</div>
									</div>
									<div className="col-sm-8">
										<div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
											<textarea style={{ width: '100%', height: "100px" }} name="resolution" type="text" placeholder="Enter Description Here" value={this.state.resolution.value} onChange={this.handleChange} />
										</div>
										<span className="help-block">{this.state.resolution.message}</span>

									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="btnSubmit text-center" style={{ margin: "auto" }}>
						<button className="btn btn-primary" onClick={() => this.addDisputeCategory()}>Ok</button>&nbsp;
                        <button className="btn btn-primary" onClick={this.props.closeAddDisputeModal}>Cancel</button>
					</div>
				</Modal.Footer>
			</Modal >
		);
	}
}
function mapStateToProps(state, ownProps) {
	return {
		disputeContentAdded: state.dispute.disputeContentAdded,
		disputeCategories: state.dispute.listingAdmin,
		// AddDispute: state.AddDispute
	};
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		disputeActions: bindActionCreators(disputeActions, dispatch),

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(AddDispute);